import { createContext, ReactNode, useState } from 'react';

export interface SidebarNavigationContextType {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SidebarNavigationContext =
  createContext<SidebarNavigationContextType>({
    isOpen: false,
    setIsOpen: () => {},
  });

const SidebarNavigationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <SidebarNavigationContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </SidebarNavigationContext.Provider>
  );
};

export default SidebarNavigationProvider;
